import { Layout, Button, Grid, Space } from "antd";
import { useAuth } from "../../store/AuthContext";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../LanguageSwitcher";

const { Header } = Layout;
const { useBreakpoint } = Grid;

const HeaderBar: React.FC = () => {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Header
      style={{
        background: "#fff",
        padding: isMobile ? "12px 16px" : "0 24px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 12,
      }}
    >
      {/* Left corner - Language */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <LanguageSwitcher />
      </div>

      {/* Right corner - Username and Logout */}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {!isMobile && <span>{user?.username}</span>}
        <Button type="primary" size="small" onClick={logout}>
          {t('logout')}
        </Button>
      </div>
    </Header>
  );
};

export default HeaderBar;
